import "../styles/Home.css";
import profileImage from "../assets/profile6.webp";

const Home: React.FC = () => {
  return (
    <section className="home section" id="home">
      <div className="home-content">
          <div className="text-container">
            <p>introduction</p>
            <h1>Hey there! I'm Vivi, a software developer based in Berlin</h1>
            <a className="explore-work-button" href="#projects">explore my work &rarr;</a>
          </div>
        <div className="profile-image-container">
            <img src={profileImage} alt="Vivienne" className="profile-image" />
        </div>
      </div>
    </section>
  );
};

export default Home;
